import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { ContainerLayout } from '@/components/ContainerLayout';
import { AdminLevelsTable } from '@/components/admin-levels/table/AdminLevelsTable';
import { backendApiAdminLevelsFindAllOptions } from '@/modules/api/@tanstack/react-query.gen';

export function AdminLevelsRoute() {
  const { data, isFetching } = useQuery(backendApiAdminLevelsFindAllOptions());

  return (
    <ContainerLayout>
      <AdminLevelsTable data={data} isFetching={isFetching} fullHeight />
    </ContainerLayout>
  );
}

export const Route = createFileRoute('/_authenticated/_management/administration/verwaltungsebenen/')({
  component: AdminLevelsRoute,
});
